import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { JAPAN_REQS } from "../utils/helpers";

export default function RequirementsPage() {
  return (
    <>
      <Navbar />
      <div className="page">
        <div className="container-narrow">
          <div className="page-header">
            <h1 className="page-title">Requirements</h1>
            <p className="page-subtitle">What to prepare and bring to our agency office before requesting your endorsement.</p>
          </div>

          <div className="card">
            <h3 style={{ fontSize: 16, marginBottom: 16 }}><i className="ti ti-list-details"></i> Documents Checklist</h3>
            <ol style={{ paddingLeft: 20 }}>
              {JAPAN_REQS.map((r, i) => (
                <li key={i} style={{ marginBottom: 10, lineHeight: 1.6 }}>{r}</li>
              ))}
            </ol>
          </div>

          <div className="card mt-24" style={{ background: "var(--cream-warm)", border: "1px solid var(--gold-200)" }}>
            <h3 style={{ fontSize: 16, marginBottom: 12 }}><i className="ti ti-info-circle"></i> Important Note</h3>
            <p style={{ marginBottom: 12 }}>
              Requirements must be submitted at the agency office. An Endorsement Letter is required.
            </p>
            <p style={{ marginBottom: 12 }}>If you don't have one, we can provide:</p>
            <p style={{ marginBottom: 12 }}>
              <strong>3 Documents</strong> → Endorsement Letter, Company Certificate, and DTI Certificate
              (registered &amp; verified in Golden Gateway Agency for Food Processing/Meat Processing, Baker, Laundry, Farming).
            </p>
            <p style={{ marginBottom: 12 }}>
              <strong>Fee: ₱6,000</strong> (to proceed with endorsement required by the agency).
            </p>
            <p style={{ marginBottom: 0 }}>
              Re-endorsing for Baker and Laundry is free since it is already included in your payment.
            </p>
          </div>

          <div className="card mt-24 text-center">
            <p className="text-muted mb-16" style={{ fontSize: 13 }}>Have your requirements ready? Request your endorsement now.</p>
            <Link to="/apply" className="btn btn-primary"><i className="ti ti-file-plus"></i> Request Endorsement</Link>
          </div>
        </div>
      </div>
    </>
  );
}
